export enum REFINANCE_SEARCH_TYPE {
  INCLUDE = 'INCLUDE',
  EXCLUDE = 'EXCLUDE',
  ONLY = 'ONLY',
}
